import esforcoSubmaximoFluxoVolume from '../../src/assets/grafico-invalidacoes/esforco-submaximo/esforcosubmaximoFvsV.png'
import esforcoSubmaximoVolumeTempo from '../../src/assets/grafico-invalidacoes/esforco-submaximo/esforcosubmaximoVvsT.png'
import fluxoNegativoFluxoVolume from '../../src/assets/grafico-invalidacoes/fluxo-zero-negativo/fluxozeronegativoFvsV.png'
import fluxoNegativoVolumeTempo from '../../src/assets/grafico-invalidacoes/fluxo-zero-negativo/fluxozeronegativoVvsT.png'
import fluxoPositivoFluxoVolume from '../../src/assets/grafico-invalidacoes/fluxo-zero-positivo/fluxozeropositivoFvsV.png'
import fluxoPositivoVolumeTempo from '../../src/assets/grafico-invalidacoes/fluxo-zero-positivo/fluxozeropositivoVvsT.png'
import hesitacaoInicialFluxoVolume from '../../src/assets/grafico-invalidacoes/hesitacao-inicial/hesitacaoinicialFvsV.png'
import hesitacaoInicialVolumeTempo from '../../src/assets/grafico-invalidacoes/hesitacao-inicial/hesitacaoinicialVvsT.png'
import inspiracaoIncompletaFluxoVolume from '../../src/assets/grafico-invalidacoes/inspiracao-incompleta/inspiracaoincompletaFvsV.png'
import inspiracaoIncompletaVolumeTempo from '../../src/assets/grafico-invalidacoes/inspiracao-incompleta/inspiracaoincompletaVvsT.png'
import interrupcaoPrecoceFluxoVolume from '../../src/assets/grafico-invalidacoes/interrupcao-precoce/interrupcaoprecoceFvsV.png'
import interrupcaoPrecoceVolumeTempo from '../../src/assets/grafico-invalidacoes/interrupcao-precoce/interrupcaoprecoceVvsT.png'
import obstrucaoFluxoVolume from '../../src/assets/grafico-invalidacoes/obstrucao-de-fluxo/obstrucaodefluxoFvsV.png'
import obstrucaoVolumeTempo from '../../src/assets/grafico-invalidacoes/obstrucao-de-fluxo/obstrucaodefluxoVvsT.png'
import oscilacaoFluxoVolume from '../../src/assets/grafico-invalidacoes/oscilacao-de-fluxo/oscilacaodefluxoFvsV.png'
import oscilacaoVolumeTempo from '../../src/assets/grafico-invalidacoes/oscilacao-de-fluxo/oscilacaodefluxoVvsT.png'
import respiracaoExtrasFluxoVolume from '../../src/assets/grafico-invalidacoes/respiracao-extras/respiracoesextrasFvsV.png'
import respiracaoExtrasVolumeTempo from '../../src/assets/grafico-invalidacoes/respiracao-extras/respiracoesextrasVvsT.png'
import tosseFluxoVolume from '../../src/assets/grafico-invalidacoes/tosse/tosseFvsV.png'
import tosseVolumeTempo from '../../src/assets/grafico-invalidacoes/tosse/tosseVvsT.png'

export const graficosInvalidacao = {

  'ESFORÇO SUBMÁXIMO': {
    fluxoVolume: esforcoSubmaximoFluxoVolume,
    volumeTempo: esforcoSubmaximoVolumeTempo
  },

  'FLUXO ZERO NEGATIVO': {
    fluxoVolume: fluxoNegativoFluxoVolume,
    volumeTempo: fluxoNegativoVolumeTempo
  },

  'FLUXO ZERO POSITIVO': {
    fluxoVolume: fluxoPositivoFluxoVolume,
    volumeTempo: fluxoPositivoVolumeTempo
  },

  'HESITAÇÃO INICIAL': {
    fluxoVolume: hesitacaoInicialFluxoVolume,
    volumeTempo: hesitacaoInicialVolumeTempo
  },

  'INSPIRAÇÃO INCOMPLETA': {
    fluxoVolume: inspiracaoIncompletaFluxoVolume,
    volumeTempo: inspiracaoIncompletaVolumeTempo
  },

  'INTERRUPÇÃO PRECOCE': {
    fluxoVolume: interrupcaoPrecoceFluxoVolume,
    volumeTempo: interrupcaoPrecoceVolumeTempo
  },

  'OBSTRUÇÃO DE FLUXO': {
    fluxoVolume: obstrucaoFluxoVolume,
    volumeTempo: obstrucaoVolumeTempo
  },

  'OSCILAÇÃO DE FLUXO': {
    fluxoVolume: oscilacaoFluxoVolume,
    volumeTempo: oscilacaoVolumeTempo
  },

  'RESPIRAÇÕES EXTRAS': {
    fluxoVolume: respiracaoExtrasFluxoVolume,
    volumeTempo: respiracaoExtrasVolumeTempo
  },

  'TOSSE': {
    fluxoVolume: tosseFluxoVolume,
    volumeTempo: tosseVolumeTempo
  },

};